import {
    SET_LOAD_OVERLAY,
    SET_ALERT_NOTIFICATION,
    SET_PERSON_TYPES,
    SET_META,
    SET_TABLE_STATE,
    RESET_META,
    ADD_META,
    SET_LAST_LOADED_TABLE,
} from './types';

export default {
    [SET_LOAD_OVERLAY](state: { loadOverlay: boolean; }, loadOverlay: boolean) {
        state.loadOverlay = loadOverlay;
    },
    [SET_ALERT_NOTIFICATION](state: { notification: any; }, data: any) {
        state.notification.show = data.show;
        if (data.type) {
            state.notification.type = state.notification.messages[data.type];
        }
        if (data.custom) {
            state.notification.type = data.custom;
        }
    },
    [SET_PERSON_TYPES](state: { personTypes: any; }, personTypes: any) {
        state.personTypes = personTypes;
    },
    [SET_META](state: { meta: any; }, meta: any) {
        state.meta = meta;
    },
    [RESET_META](state: { meta: any; }) {
        state.meta = [];
    },
    [ADD_META](state: { meta: any; }, metaMutation: {name: string, meta: any}) {
        state.meta[metaMutation.name] = metaMutation.meta;
    },
    [SET_TABLE_STATE](state: { tableStates: any; }, mutation: {name: string, tableState: any}) {
        state.tableStates[mutation.name] = mutation.tableState;
    },
    [SET_LAST_LOADED_TABLE](state: { lastLoadedTable: string; }, tableName: string) {
        state.lastLoadedTable = tableName;
    },
};

